var _circle, _circle2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkillsBannerIcon1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 62.25,
    stroke: "#434652",
    strokeWidth: 19.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 24,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.25 21.7501C143.25 20.2334 142.336 18.866 140.935 18.2856C139.534 17.7051 137.921 18.026 136.848 19.0985L118.848 37.0985C118.145 37.8017 117.75 38.7555 117.75 39.7501V56.9467L87.3483 87.3483C85.8839 88.8128 85.8839 91.1872 87.3483 92.6516C88.8128 94.1161 91.1872 94.1161 92.6517 92.6516L123.803 61.5001H139.5C140.495 61.5001 141.448 61.105 142.152 60.4018L160.152 42.4018C161.224 41.3293 161.545 39.7163 160.965 38.315C160.384 36.9138 159.017 36.0001 157.5 36.0001H143.25V21.7501ZM131.303 54.0001H137.947L148.447 43.5001H141.803L131.303 54.0001ZM135.75 38.9467V30.8034L125.25 41.3034V49.4467L135.75 38.9467Z",
    fill: "#232327"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillsBannerIcon1);
export default __webpack_public_path__ + "static/media/skills-bannerIcon_1.ddddb0544f3d1e1095796db73a5a6d7d.svg";
export { ForwardRef as ReactComponent };